import { VIEW_VERSIONS } from '@cognite/apm-client';

export function getViewVersion(sourceView: 'TemplateItem' | 'ChecklistItem') {
  switch (sourceView) {
    case 'TemplateItem':
      return VIEW_VERSIONS.TEMPLATE_ITEM;
    case 'ChecklistItem':
      return VIEW_VERSIONS.CHECKLIST_ITEM;
  }
}
